import { paths } from 'routes/paths';
import { History } from 'history';

const navigateToAppliedProduct = ({
  applicationId,
  taskId,
  recordName,
  feApplicationsActive,
  history
}: {
  applicationId?: string;
  taskId?: string;
  recordName?: string;
  feApplicationsActive: boolean;
  history: History;
}) => {
  const operationId = applicationId || taskId;

  if (!operationId) {
    return;
  }

  if (!feApplicationsActive) {
    if (taskId) {
      history.push(`${paths.tasks}/${taskId}/view`);
    }
    return;
  }

  const params = new URLSearchParams();
  if (recordName) {
    params.set('search', recordName);
  }

  history.push({
    pathname: paths.applications,
    search: params.toString() ? `?${params.toString()}` : '',
    state: {
      operationId
    }
  });
};

export default navigateToAppliedProduct;
